/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ExportCommentsWidget_report = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportCommentsWidget_report",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "withReportFilterProps_report",
      "args": null
    }
  ],
  "type": "Report"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/UserReportGrid/components/ExportCommentsWidget/__generated__/ExportCommentsWidget_report.graphql.js